import React, { useEffect } from 'react';
import DialogModal from '../../utils/DialogModal';


const UnknownErrorDialog = ({ open, details, close }: { open: boolean, details: string, close: () => any }) => {

    return (
        <DialogModal open={open} onClose={() => { open = false; close(); }} iconClass={"exclam"} buttonOk={"OKAY"}>
            <>
                <p>
                    Uh oh! An unknown error occurred.
                </p>
                {details && <p>
                    Details: {details}
                </p>}
            </>
        </DialogModal>
    )
}

export default UnknownErrorDialog;
